"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./qrCodePopup.scss");
var _soundIcon = _interopRequireDefault(require("../assets/sound-icon.svg"));
var _qrError = _interopRequireDefault(require("../assets/qr-error.json"));
var _RenderAnimation = _interopRequireDefault(require("../../teacherDashboard/teacher/lotties/RenderAnimation"));
var _state = require("../state");
var _incorrectQrcode = _interopRequireDefault(require("../assets/incorrect-qrcode.mp3"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var QRcodePopup = function QRcodePopup(_ref) {
  var _ref$errorInfo = _ref.errorInfo,
    errorInfo = _ref$errorInfo === void 0 ? null : _ref$errorInfo,
    setLoading = _ref.setLoading,
    setError = _ref.setError;
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    showQRPopup = _useAuthSigninState.showQRPopup,
    setShowQRPopup = _useAuthSigninState.setShowQRPopup;
  if (!errorInfo && !showQRPopup) {
    return null;
  }
  var audio = new Audio(_incorrectQrcode["default"]);
  (0, _react.useEffect)(function () {
    audio.play();
    trackEventsForGuests("Viewed SplashLearn QR Code Required Popup", {
      "mp_login_user_type": "student"
    }, {
      send_mixpanel: true
    });
    return function () {
      audio.pause();
    };
  }, []);
  var QRCodeExpired = (0, _react.useMemo)(function () {
    if (errorInfo === "This QR code is expired. Please contact your teacher.") {
      return true;
    } else {
      return false;
    }
  }, [errorInfo]);
  var loginViaClassCode = function loginViaClassCode() {
    window.location.hash = "#student-klasscode?fromPage=QR code Required Popup";
    trackEventsForGuests("Interacted SplashLearn QR code Required Popup", {
      "mp_login_user_type": "student",
      "Clicked on": "Login via class code"
    }, {
      send_mixpanel: true
    });
  };
  var scanAgain = function scanAgain(clickedOn) {
    setLoading(false);
    setError(null);
    setShowQRPopup(false);
    trackEventsForGuests("Interacted SplashLearn QR code Required Popup", {
      "mp_login_user_type": "student",
      "Clicked on": clickedOn
    }, {
      send_mixpanel: true
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "qr-code-popup",
    "data-sentry-component": "QRcodePopup",
    "data-sentry-source-file": "QRcodePopup.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "qr-code-overlay"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "qr-code-popup"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "iconcust-iconCross cross-icon",
    onClick: function onClick() {
      return scanAgain("Cross");
    }
  }), /*#__PURE__*/_react["default"].createElement(_soundIcon["default"], {
    className: "sound-icon",
    onClick: function onClick() {
      return audio.play();
    },
    "data-sentry-element": "SoundIconSvg",
    "data-sentry-source-file": "QRcodePopup.tsx"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, QRCodeExpired ? "The QR code is expired" : "SplashLearn QR code required"), /*#__PURE__*/_react["default"].createElement("p", null, QRCodeExpired ? "Ask your teacher for help." : "Please make sure that you are scanning the SplashLearn QR code."), /*#__PURE__*/_react["default"].createElement("div", {
    id: "qr-err-animation"
  }), /*#__PURE__*/_react["default"].createElement(_RenderAnimation["default"], {
    animationJSON: _qrError["default"],
    animationName: 'icon-animation',
    animationDivId: 'qr-err-animation',
    "data-sentry-element": "RenderAnimation",
    "data-sentry-source-file": "QRcodePopup.tsx"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "qr-code-btns"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "".concat(!QRCodeExpired ? "class-code" : ""),
    onClick: loginViaClassCode
  }, "Login via class code"), !QRCodeExpired ? /*#__PURE__*/_react["default"].createElement("button", {
    className: "scan-again",
    onClick: function onClick() {
      return scanAgain("Retry");
    }
  }, "Scan again") : null))));
};
var _default = QRcodePopup;
exports["default"] = _default;